import React from 'react';

import { Endpoint, isContrato, ReportService } from '@philips-emr/hpms-stipulator-commons';
import { Button, Card, Image } from '@philips-emr/tws-components';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import './hpms-tabela-preco.scss';
import { HistoryService } from '@philips-emr/tws-core/lib/services';

import HpmsTabelaPrecoBase from './hpms-tabela-preco-base';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
export default class HpmsTabelaPreco extends HpmsTabelaPrecoBase {

  constructor(props) {
    super(props);
  }

  render() {
    const { nmTabela, dtInicioVigencia, nrSeqTabelaPreco } = this.props;

    return (
      <Card width={12} key={nrSeqTabelaPreco} className="c-tabela-preco">
        <div className={`c-tabela-preco__card-wrap c-tabela-preco-interior__border`}>
          <div className="c-tabela-preco__card-content">
            <Image src="/static/assets/chart-40-40.svg" />
          </div>

          <div className="c-tabela-preco__card-content">
            <div>{dtInicioVigencia}</div>
          </div>

          <div className="c-tabela-preco__card-content">
            <div>{nmTabela}</div>
          </div>

          <div className="c-tabela-preco__card-content c-tabela-preco__card-print">
            <Button
              key="hpms-print"
              icon="/static/assets/hpms-print-gray.svg"
              theme="quiet-emphasis"
              value=""
              iconPlacement="left"
              enabled={this.exibeImprimir()}
              onClick={() => this.onClickPrint()}
            />
          </div>
        </div>
      </Card>
    );
  }

  onClickPrint() {

    const { nrSeqContrato } = HistoryService.getCurrentRouteParams();
    const { nrSeqTabelaPreco } = this.props;

    const reportService = new ReportService('9', Endpoint.GET.RELATORIOS_POR_GRUPO);
    void reportService.getRelatoriosByCdGrupo()
      .then(() => {
        if (isContrato()) {
          reportService.abreListaRelatorios({ NR_SEQ_CONTRATO: nrSeqContrato, NR_SEQ_TABELA: nrSeqTabelaPreco });
        } else {
          reportService.abreListaRelatorios({ NR_SEQ_INTERCAMBIO: nrSeqContrato, NR_SEQ_TABELA: nrSeqTabelaPreco });
        }

      });

  }

  exibeImprimir() {

    const reportService = new ReportService('9', Endpoint.GET.RELATORIOS_POR_GRUPO);
    void reportService.getRelatoriosByCdGrupo()
      .then((response) => {
        if (response.length === 0) {
          return false;
        }

        return true;
      });

  }

}
